import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAmenities, selectAmenities, selectAmenitiesLoading } from '../../store/slices/amenities';

import {
  Container,
  List,
} from './styled';

import Item from './Item';
import ItemPlaceholder from './ItemPlaceholder';
import ListingListState from '../../components-shared/ListingListState';

const AmenitiesList = () => {
  const dispatch = useDispatch();

  const { search } = window.location;
  const params = new URLSearchParams(search);
  const association_id = params.get('association_id');

  const amenities = useSelector(selectAmenities);
  const isLoading = useSelector(selectAmenitiesLoading);

  useEffect(() => {
    if (!association_id) {
      return;
    }

    dispatch(getAmenities({ association_id }));
  }, [association_id, dispatch]);

  const onReserve = (item) => {
    const { association: { association_id }, amenity_id, application_url } = item;
    window.open(`${application_url}/amenities/redirect_to?association_id=${association_id}&amenity_id=${amenity_id}`);
  };

  if (!amenities.length && !isLoading) {
    return <ListingListState type="no_amenities" />;
  }

  return (
    <Container>
      <List>
        {isLoading
          ? [1, 2, 3, 4].map((item) => <ItemPlaceholder key={item} />)
          : amenities.map((item) => <Item key={item.amenity_id} item={item} onReserve={onReserve} />)}
      </List>
    </Container>
  );
};

export default AmenitiesList;
